import { render, staticRenderFns } from "./debug-lint.vue?vue&type=template&id=2fcd36d9&scoped=true&"
import script from "./debug-lint.vue?vue&type=script&lang=js&"
export * from "./debug-lint.vue?vue&type=script&lang=js&"
import style0 from "./debug-lint.vue?vue&type=style&index=0&id=2fcd36d9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcd36d9",
  null
  
)

export default component.exports